'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import { InterfaceChainUtils } from '@morpho-org/dapp-core';
import { useQuery } from '@tanstack/react-query';
import { type Address, getAddress } from 'viem';
import { ButtonLink } from '@/components/common/ButtonLink';
import { getVaultUrl } from '@/helpers/routing';
import { orpc } from '@/lib/orpc/client';
import UserCellDashboard from './UserCellDashboard';
interface AdapterInfo {
  vaultName: string;
  assetLogoURI: string | null;
  href: string;
}
export interface UserCellVaultAwareProps {
  address: Address;
  chainId: ChainId;
}
const UserCellVaultAware = t0 => {
  const $ = _c(22);
  const {
    address,
    chainId
  } = t0;
  let t1;
  if ($[0] !== chainId) {
    t1 = orpc.vaultV2.adapterLookup.queryOptions({
      input: {
        chainId
      },
      staleTime: 600000
    });
    $[0] = chainId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data
  } = useQuery(t1);
  let t2;
  if ($[2] !== chainId || $[3] !== data) {
    bb0: {
      const map = new Map();
      if (!data) {
        t2 = map;
        break bb0;
      }
      const identifier = InterfaceChainUtils.getIdentifierById(chainId);
      for (const {
        adapterAddress,
        vault
      } of data.items) {
        map.set(getAddress(adapterAddress), {
          vaultName: vault.name,
          assetLogoURI: vault.assetLogoUri,
          href: getVaultUrl({
            identifier,
            vaultAddress: vault.address,
            vaultName: vault.name
          })
        });
      }
      t2 = map;
    }
    $[2] = chainId;
    $[3] = data;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const adapterMap = t2;
  let t3;
  if ($[5] !== adapterMap || $[6] !== address) {
    let t4;
    if ($[8] !== address) {
      t4 = getAddress(address);
      $[8] = address;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t3 = adapterMap.get(t4);
    $[5] = adapterMap;
    $[6] = address;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const adapterInfo = t3;
  if (!adapterInfo) {
    let t4;
    if ($[10] !== address) {
      t4 = <UserCellDashboard address={address} />;
      $[10] = address;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    return t4;
  }
  let t4;
  if ($[12] !== adapterInfo.vaultName) {
    t4 = <span className="text-2xs text-foreground line-clamp-1">{adapterInfo.vaultName}</span>;
    $[12] = adapterInfo.vaultName;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== adapterInfo.assetLogoURI) {
    t5 = {
      src: adapterInfo.assetLogoURI
    };
    $[14] = adapterInfo.assetLogoURI;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t4 || $[17] !== t5) {
    t6 = {
      variant: "ghost",
      size: "default",
      label: t4,
      avatarProps: t5
    };
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== adapterInfo.href || $[20] !== t6) {
    t7 = <ButtonLink href={adapterInfo.href} mode="internal" buttonProps={t6} />;
    $[19] = adapterInfo.href;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};
export default UserCellVaultAware;